import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'babel-polyfill'
import './assets/icon/iconfont.css'
// import 'lib-flexible/flexible'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import VueAwesomeSwiper from 'vue-awesome-swiper'
//中英文切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang')?sessionStorage.getItem('lang'):'zh',    // 语言标识
  messages: {
      'zh': require('./assets/lang/zh'),
      'en': require('./assets/lang/en')
  }
})
// import style (>= Swiper 6.x)
//import 'swiper/swiper.css'
Vue.use(VueAwesomeSwiper)

import './common/font.css'

import animated from 'animate.css'
Vue.use(animated)
Vue.config.productionTip = false
import {  Carousel,CarouselItem,Tabs,TabPane,Backtop,Pagination} from 'element-ui';
Vue.use(Carousel).use(CarouselItem).use(Tabs).use(TabPane).use(Backtop).use(Pagination)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
